import { OrganizationKeyName } from "../../../../model/Organization";

export const GET_USER_VOUCHER_FAIL = "SHOP:GET_USER_VOUCHER_FAIL";

export const getUserVoucherFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_USER_VOUCHER_FAIL as typeof GET_USER_VOUCHER_FAIL,
  organization,
  id,
});

export type GetUserVoucherFailAction = ReturnType<
  typeof getUserVoucherFailAction
>;
